export default "__VITE_ASSET__CXPjimJh__"